// This file is generated automatically by `scripts/build/fp.ts`. Please, don't change it.

import { eachWeekendOfYear as fn } from "../eachWeekendOfYear.js";
import { convertToFP } from "./_lib/convertToFP.js";

export const eachWeekendOfYearWithOptions = convertToFP(fn, 2);

// Fallback for modularized imports:
export default eachWeekendOfYearWithOptions;
